var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-messages" },
    [
      _vm.templateMessageModal
        ? _c("TemplateMessageModal", {
            attrs: {
              template: _vm.templateMessageModal,
              "channel-id": _vm.contact.channel,
            },
            on: {
              close: function ($event) {
                _vm.templateMessageModal = null
              },
              send: _vm.sendTemplate,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.channels.length === 0
        ? _c("div", { staticClass: "empty" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v("Whatsapp Kanalı Bulunamadı"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "message" }, [
              _vm._v("Sistem üzerinde bir whatsapp kanalı bulunamadı."),
            ]),
          ])
        : [
            _c(
              "div",
              { staticClass: "items" },
              [
                _vm.channelTemplates.length <= 0
                  ? _c("div", [_vm._v("Template bulunamadı")])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.channelTemplates, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: item._id,
                      staticClass: "item-card",
                      class: {
                        selected: _vm.pointerIndex === index,
                        hoverSelected: _vm.pointerIndex === index,
                      },
                      attrs: { "data-id": item._id, "data-pointer": index },
                      on: {
                        click: function ($event) {
                          return _vm.useTemplate(item)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "title-wrapper" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(item.elementName) +
                              "\n                    "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "message-preview" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(item.data) +
                            "\n                "
                        ),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }